<template>
    <div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 class="text-xl font-bold mb-4 text-gray-800">Edit Order</h2>
        <form @submit.prevent="submitOrder">
          <input v-model="localOrder.client.name" class="w-full p-2 border rounded-lg mb-4" placeholder="Client Name" required />
          <input v-model="localOrder.totalAmount" type="number" class="w-full p-2 border rounded-lg mb-4" placeholder="Total Amount" required />
          <input v-model="localOrder.status" class="w-full p-2 border rounded-lg mb-4" placeholder="Status" required />
          <button type="submit" class="w-full bg-green text-white p-2 rounded-lg">Update Order</button>
        </form>
        <button @click="closeModal" class="mt-4 w-full text-gray-600">Cancel</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      order: {
    
      },
    },
    data() {
      return {
        localOrder: { ...this.order }, // Create a local copy of the staff prop
      };
    },
    methods: {
      submitOrder() {
        this.$emit('editOrder', this.localOrder);
        this.closeModal();
      },
      closeModal() {
        this.$emit('closeModal');
      },
    },
  };
  </script>
  